import { Component, Input } from "@angular/core";
import { TradeSuccessComponent } from "../trade-success/trade-success.component";

/* eslint-disable @angular-eslint/relative-url-prefix */
@Component({
	selector: "trade-pending",
	templateUrl: "./trade-pending.component.html",
	styleUrls: ["./../success-screen.component.scss"],
	standalone: false
})
export class TradePendingComponent extends TradeSuccessComponent {
	@Input()
	public walletExists: boolean = true;
}
